"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDataWeb = void 0;
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var utils_1 = require("@dp-instant/utils");
var UserDataBase_1 = require("./UserDataBase");
var UserDataWeb = (function (_super) {
    tslib_1.__extends(UserDataWeb, _super);
    function UserDataWeb() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserDataWeb.prototype.read = function (keys) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var allKeys, obj;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                allKeys = Array.from(this.cache.keys());
                obj = {};
                (keys || allKeys).forEach(function (key) {
                    var value = _this.getCookieValue(key);
                    obj[key] = value;
                    _this.cache.set(key, value);
                });
                utils_1.log.trace(this, "read", obj);
                this.lastSync = Date.now();
                return [2];
            });
        });
    };
    UserDataWeb.prototype.write = function (keys) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var obj;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                obj = {};
                this.cache.forEach(function (v, k) {
                    if (!keys || keys.includes(k)) {
                        obj[k] = v;
                        _this.setCookieValue(k, v);
                    }
                });
                utils_1.log.trace(this, "write", obj);
                return [2];
            });
        });
    };
    UserDataWeb.prototype.getCookieValue = function (key) {
        var dataString = this.getCookie(key);
        if (dataString) {
            return JSON.parse(dataString);
        }
    };
    UserDataWeb.prototype.setCookieValue = function (key, value) {
        this.setCookie(key, typeof value === "object" ? JSON.stringify(value) : "" + value);
    };
    UserDataWeb.prototype.setCookie = function (c_name, value, expireminutes) {
        if (expireminutes === void 0) { expireminutes = 10080; }
        var exdate = new Date();
        exdate.setMinutes(exdate.getMinutes() + expireminutes);
        document.cookie =
            c_name +
                "=" +
                escape(value) +
                (expireminutes == null ? "" : ";expires=" + exdate.toUTCString());
    };
    UserDataWeb.prototype.getCookie = function (c_name) {
        var name = c_name + "=";
        var decoded_cookie = decodeURIComponent(document.cookie);
        var carr = decoded_cookie.split(";");
        for (var i = 0; i < carr.length; i++) {
            var c = carr[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    };
    UserDataWeb.COOKIE_NAME = "dp-instant";
    UserDataWeb = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], UserDataWeb);
    return UserDataWeb;
}(UserDataBase_1.UserDataBase));
exports.UserDataWeb = UserDataWeb;
//# sourceMappingURL=UserDataWeb.js.map